import { FC } from 'react';
import { useUsersControllerCheckResetPasswordCredQuery } from 'src/app/services/api.generated';
import { ChangePassword } from 'src/components/organisms/changePassword/ChangePassword';
import { ResetLinkInvalid } from 'src/components/organisms/changePassword/ResetLinkInvalid';
import LoginTemplate from 'src/components/templates/LoginTemplate';
import Loading from 'src/components/atoms/Loading';
import { Paper, useMediaQuery, useTheme, Container } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { getPasswordLinkFlow } from 'src/utils/passwordLinkFlow';

export const ForgotPassword: FC = () => {
  const theme = useTheme();
  const [searchParams] = useSearchParams();

  const resetCode = searchParams.get('resetCode');
  const email = searchParams.get('email');

  const isMd = useMediaQuery(theme.breakpoints.up('md'));

  const { data, isLoading, isError, refetch } = useUsersControllerCheckResetPasswordCredQuery(
    {
      resetCode: resetCode!,
      email: email!,
    },
    { skip: !resetCode || !email }
  );

  // The check answers false (not an error) for a wrong, expired, used or
  // superseded code. Show that instead of sending the user back.
  const linkInvalid = !resetCode || !email || isError || data === false;

  return (
    <>
      {isLoading && <Loading />}
      <LoginTemplate>
        <Container
          maxWidth="xs"
          sx={{
            px: 0,
            borderRadius: 0,
            height: { xs: '100%', sm: 'auto' },
          }}
        >
          <Paper
            elevation={isMd ? 4 : 0}
            sx={{
              height: { xs: '100%', sm: 'auto' },
            }}
          >
            {linkInvalid ? (
              <ResetLinkInvalid />
            ) : (
              !isLoading && (
                <ChangePassword
                  resetCode={resetCode}
                  email={email}
                  onResetFailed={refetch}
                  flow={getPasswordLinkFlow(searchParams.get('flow'))}
                />
              )
            )}
          </Paper>
        </Container>
      </LoginTemplate>
    </>
  );
};
